import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FriendAndPartnerForm from '../../../components/forms/FriendAndPartnerForm';
import { useCreateFriendAndPartner } from '../../../hooks/useFriendAndPartnerApi';
import { useNavigate } from 'react-router-dom';
import { FriendAndPartnerDTO } from '../../../services/apiClient';

const FriendAndPartnerCreate: React.FC = () => {
  const createFriendAndPartner = useCreateFriendAndPartner();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Friend And Partners', href: '/admin/friendandpartners' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FriendAndPartnerDTO) => {
    try {
      await createFriendAndPartner.mutateAsync(data);
      navigate('/admin/friendandpartners');
    } catch (error) {
      console.error('Error creating FriendAndPartner:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/friendandpartners"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FriendAndPartner.Edit'
    >
      <FriendAndPartnerForm
        initialValues={{} as FriendAndPartnerDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/friendandpartners')}
      />
    </AdminLayout>
  );
};

export default FriendAndPartnerCreate;
